import { useEffect, useState, useMemo } from "react";
import { format, addDays } from "date-fns";

interface ISelectedDateProps {
  selectedDate?: string;
  setSelectedDate?: (date: string) => void;
}

const QuickDateFilters: React.FC<ISelectedDateProps> = ({ selectedDate, setSelectedDate }) => {
  // ✅ Memoize today's date — prevents infinite re-renders
  const today = useMemo(() => new Date(), []);
  const [dateOptions, setDateOptions] = useState<{ label: string; date: Date }[]>([]);

  useEffect(() => {
    setDateOptions([
      { label: "Today", date: today },
      { label: "Tomorrow", date: addDays(today, 1) },
      { label: "", date: addDays(today, 2) },
      { label: "", date: addDays(today, 3) },
    ]);
  }, [today]); // safe now since `today` never changes

  return (
    <div className="flex justify-start items-center w-full gap-2">
      {dateOptions.map((item) => {
        const displayDate = format(item.date, "EEE d, MMM");
        const formattedValue = format(item.date, "yyyy-MM-dd");
        const isSelected = selectedDate === formattedValue;

        return (
          <button
            key={item.label}
            type="button"
            onClick={() => setSelectedDate && setSelectedDate(formattedValue)}
            className={`px-6 py-1    whitespace-nowrap flex rounded-full font-medium text-sm ${
              isSelected
                ? " text-[#000000] border-[#000000]  border-[1.5px]"
                : " border-[1px] bg-[#F4F4F4] text-[#6C727F] border-[#E2E2E2] "
            }`}
          >
            <span>{item.label}</span>
            {!["Today", "Tomorrow"].includes(item.label) && <span className="">{displayDate}</span>}
          </button>
        );
      })}
    </div>
  );
};

export default QuickDateFilters;
